(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/info/info.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/info/info.js');
"use strict";


const InfoPage = () => {
  const {
    useParams,
    useHistory
  } = ReactRouterDOM;
  const history = useHistory();
  const {
    useEffect
  } = React;
  const {
    hideFooter,
    showFooter
  } = svs.eInstant.util;
  const {
    InfoProvider,
    Info
  } = svs.eInstant.shared.info;
  const {
    gameUrl
  } = useParams();
  const game = svs.eInstant.data.gameConfigs.find(game => game.url === gameUrl);
  svs.eInstant.shared.hooks.useMetaTags(game);
  const onClose = e => {
    e === null || e === void 0 || e.preventDefault();
    history.push(svs.eInstant.constants.ROUTES.LOBBY);
  };
  useEffect(() => {
    hideFooter();
    return showFooter;
  }, [hideFooter, showFooter]);
  return React.createElement(InfoProvider, {
    gameUrl: useParams().gameUrl
  }, React.createElement(Info, {
    onClose: onClose,
    show: true
  }));
};
setGlobal('svs.eInstant.info.Info', InfoPage);

 })(window);